<template>
    <div class="learningpath-subscribe-button">
        <TotemButton
            v-if="!isSubscribed"
            :icon="getIconBasedOnSubscription"
            :color="getSubscribeButtonColor"
            @click="subscribeToLearningPath"
            :label="getSubscribeText"
        />
        <TotemButton
            v-else
            :icon="getIconBasedOnSubscription"
            :color="getSubscribeButtonColor"
            @click="unSubscribeToLearningPath"
            :label="getSubscribeText"
        />
    </div>
</template>

<script>
    export default {
        name: 'learning-path-banner-subscribe-button',
        props: {
            isSubscribed: {
                type: Boolean,
                default: false
            },
            learningPathId: {
                type: Number,
                default: null
            }
        },
        computed: {
            getSubscribeText () {
                return this.isSubscribed ? this.$t('LearningPath.unsubscribe') : this.$t('LearningPath.subscribe')
            },
            getIconBasedOnSubscription () {
                return this.isSubscribed ? 'blocked' : 'play3'
            },
            getSubscribeButtonColor () {
                return this.isSubscribed ? 'secondary' : 'primary'
            }
        },
        methods: {
            async subscribeToLearningPath () {
                try {
                    await this.$store.dispatch('LearningPaths/subscribeToLearningPath', this.learningPathId)
                } catch (error) {
                    console.log(error)
                }
            },
            async unSubscribeToLearningPath () {
                try {
                    await this.$store.dispatch('LearningPaths/unSubscribeToLearningPath', this.learningPathId)
                } catch (error) {
                    console.log(error)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.learningpath-subscribe-button {
    display: flex;
    justify-content: center;

    [class*="mobile"] & {
        margin: 10px 0 10px 0;
    }

}
</style>
